<template>
    <div>
        <h1 v-if="!id">{{ form.id ? 'Ändra' : 'Skapa' }} kund</h1>
        <hr />
        <div>
            <b-tabs v-model="activeTab" content-class="mt-3">
                <b-tab title="Grunddata">
                    <b-form @submit.prevent="onSubmit">
                        <b-form-group id="input-group-customerNo"
                                      label="Kundnr"
                                      label-for="input-customerNo">
                            <b-form-input id="input-customerNo"
                                          v-model="form.customerNo"
                                          type="text"
                                          placeholder="Ange kundnr"
                                          :disabled="isSubmitting"
                                          autocomplete="off"
                                          aria-describedby="input-customerNo-help-block"
                                          required />
                            <b-form-text id="input-customerNo-help-block">
                                <ul class="text-danger mb-0">
                                    <li v-for="message in validationByKey('CustomerNo')"
                                        :key="message">
                                        {{ message }}
                                    </li>
                                </ul>
                            </b-form-text>
                        </b-form-group>

                        <b-form-group id="input-group-name"
                                      label="Namn"
                                      label-for="input-name">
                            <b-form-input id="input-name"
                                          v-model="form.name"
                                          type="text"
                                          placeholder="Ange namn"
                                          :disabled="isSubmitting"
                                          autocomplete="off"
                                          aria-describedby="input-name-help-block"
                                          required />
                            <b-form-text id="input-name-help-block">
                                <ul class="text-danger mb-0">
                                    <li v-for="message in validationByKey('Name')" :key="message">
                                        {{ message }}
                                    </li>
                                </ul>
                            </b-form-text>
                        </b-form-group>

                        <b-form-group id="input-group-customerType" label="Typ" label-for="input-customerType">
                            <b-form-select id="input-customerType"
                                           v-model="form.customerType"
                                           :options="customerTypes"
                                           :disabled="isSubmitting"
                                           aria-describedby="input-customerType-help-block"
                                           required />
                            <b-form-text id="input-customerType-help-block">
                                <ul class="text-danger mb-0">
                                    <li v-for="message in validationByKey('CustomerType')" :key="message">
                                        {{ message }}
                                    </li>
                                </ul>
                            </b-form-text>
                        </b-form-group>

                        <!------------------------------------>
                        <template v-if="isEditMode">
                            <hr />
                            <small style="font-size:90%;" class="text-muted">Kundansvarig</small>

                            <b-form-group v-if="isEditMode" id="input-group-responsible" label="Välj" label-for="input-responsible">
                                <b-form-select id="input-responsible"
                                               v-model="form.responsible"
                                               :options="responsibles"
                                               value-field="userId"
                                               text-field="userFullName"
                                               :disabled="isSubmitting"
                                               aria-describedby="input-responsible-help-block"
                                               required>
                                </b-form-select>
                                <b-form-text id="input-responsible-help-block">
                                    <ul class="text-danger mb-0">
                                        <li v-for="message in validationByKey('Responsible')" :key="message">
                                            {{ message }}
                                        </li>
                                    </ul>
                                </b-form-text>
                            </b-form-group>


                            <b-form-group id="input-group-responsibleReminders" label="Mailutskick" label-for="input-responsibleReminders">
                                <b-form-checkbox-group id="input-responsibleReminders"
                                                       v-model="selectedResponsibleReminders"
                                                       :options="responsibleReminderOptions"
                                                       class="mb-3"
                                                       value-field="item"
                                                       text-field="name">
                                </b-form-checkbox-group>
                                <b-form-text id="input-responsibleReminders-help-block">
                                    <ul class="text-danger mb-0">
                                        <li v-for="message in validationByKey('ResponsibleReminders')" :key="message">
                                            {{ message }}
                                        </li>
                                    </ul>
                                </b-form-text>
                            </b-form-group>

                            <b-form-group id="input-group-responsibleMailAfterXReminders" label="Få mail efter x" label-for="input-responsibleMailAfterXReminders">

                                <b-input-group>
                                    <b-form-input id="input-responsibleMailAfterXReminders"
                                                  v-model="form.responsibleMailAfterXReminders"
                                                  type="number"
                                                  min="0"
                                                  max="999"
                                                  :disabled="isSubmitting"
                                                  aria-describedby="input-responsibleMailAfterXReminders-help-block"
                                                  required />
                                    <b-input-group-append>
                                        <b-input-group-text>antal påminnelser har skickats</b-input-group-text>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-text>
                                    0 = inga påminnelser. 1 = alla. 2 = varannan osv.
                                </b-form-text>


                                <b-form-text id="input-responsibleMailAfterXReminders-help-block">
                                    <ul class="text-danger mb-0">
                                        <li v-for="message in validationByKey('ResponsibleMailAfterXReminders')" :key="message">
                                            {{ message }}
                                        </li>
                                    </ul>
                                </b-form-text>
                            </b-form-group>

                            <b-form-group id="input-group-sendEmailToResponsibleOnly">
                                <b-form-checkbox id="input-sendEmailToResponsibleOnly"
                                                 v-model="form.sendEmailToResponsibleOnly"
                                                 aria-describedby="input-sendEmailToResponsibleOnly-help-block"
                                                 required
                                                 :disabled="isSubmitting">
                                    Skicka endast mail till kundansvarig
                                </b-form-checkbox>
                                <b-form-text id="input-sendEmailToResponsibleOnly-help-block">
                                    <ul class="text-danger mb-0">
                                        <li v-for="message in validationByKey('SendEmailToResponsibleOnly')" :key="message">
                                            {{ message }}
                                        </li>
                                    </ul>
                                </b-form-text>
                            </b-form-group>
                        </template>

                        <!------------------------------------>

                        <b-alert :show="validationByKey('Other').length > 0"
                                 variant="danger">
                            <ul class="text-danger mb-0">
                                <li v-for="message in validationByKey('Other')" :key="message">
                                    {{ message }}
                                </li>
                            </ul>
                        </b-alert>

                        <b-alert :show="successMessage.length > 0"
                                 variant="success"
                                 class="mb-0 mt-4">
                            <h6 class="mb-0 text-center">
                                <font-awesome-icon icon="info-circle" /> {{ successMessage }}
                            </h6>
                        </b-alert>

                        <b-button v-b-tooltip.hover
                                  variant="primary"
                                  type="submit"
                                  class="float-right mt-4"
                                  :class="{ 'btn-block': id }"
                                  :disabled="isSubmitting"
                                  :title="isSubmitting ? 'Sparar...' : ''">
                            <font-awesome-icon v-if="isSubmitting" icon="spinner" spin />
                            Spara
                        </b-button>
                    </b-form>
                </b-tab>
                <b-tab v-if="isEditMode" title="Behörighet" lazy>
                    <Permissions :customer-id="form.id" />
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    import { get, post } from '@/helpers/api';
    import Permissions from '@/components/customer/Permissions';

    export default {
        name: 'SaveCustomer',
        components: {
            Permissions
        },
        props: {
            id: String
        },
        data() {
            return {
                activeTab: 0,
                isSubmitting: false,
                successMessage: '',
                validationErrors: null,
                form: {
                    id: null,
                    customerNo: '',
                    name: '',
                    customerType: 0,
                    responsible: null,
                    responsibleMailAfterXReminders: 0,
                    sendEmailToResponsibleOnly: false,
                },
                responsibles: [],
                customerTypes: [
                    { value: 0, text: 'Kund' },
                    { value: 1, text: 'Demo' },
                    { value: 2, text: 'Mall' },

                ],
                selectedResponsibleReminders: [],
                responsibleReminderOptions: [
                    { item: 'A', name: 'Schema' },
                    { item: 'B', name: 'Brister' },
                ]
            };
        },
        computed: {
            isEditMode() {
                return this.form.id > 0;
            }
        },
        async mounted() {
            this.form.id = typeof this.id !== 'undefined' ? this.id : 0;

            if (this.isEditMode) {
                await get('Customer', `Get/${this.form.id}`)
                    .then((x) => {
                        this.form = x.data;

                        this.selectedResponsibleReminders = [];

                        if (this.form.scheduleReminder) {
                            this.selectedResponsibleReminders.push('A');
                        }

                        if (this.form.lackReminders) {
                            this.selectedResponsibleReminders.push('B');
                        }
                    })
                    .catch((x) => {
                        this.validationErrors = x.response.data.errors;
                    });
            }

            await this.getAllUsersByCustomerId();
        },
        methods: {
            async onSubmit() {
                this.successMessage = '';
                this.validationErrors = null;
                this.isSubmitting = true;

                const payload = {
                    ...this.form,
                    ...(this.isEditMode ? {
                        responsibleUserId: this.form.responsible,
                        scheduleReminder: this.selectedResponsibleReminders.includes('A'),
                        lackReminders: this.selectedResponsibleReminders.includes('B'),
                        responsibleMailAfterXReminders: this.form.responsibleMailAfterXReminders,
                        sendEmailToResponsibleOnly: this.form.sendEmailToResponsibleOnly,
                    } : {}),
                };

                if (!this.isEditMode) {
                    delete payload.responsibleUserId;
                    delete payload.lackReminders;
                    delete payload.scheduleReminder;
                    delete payload.responsibleMailAfterXReminders;
                    delete payload.sendEmailToResponsibleOnly;
                    delete payload.responsible;
                }


                await post('Customer', `Save/${this.form.id}`, payload)
                    .then((x) => {
                        this.form.id = x.data.entityId;
                        this.successMessage = `Sparade ${this.form.customerNo} ${this.form.name}`;
                        this.validationErrors = x.data.errors;
                    })
                    .catch((x) => {
                        this.validationErrors = x.response.data.errors;
                    });

                this.isSubmitting = false;

                if (!this.validationErrors && this.form.id) this.onCreated();
            },
            onCreated() {
                this.hasSavedSuccessfullly = true;
            },
            validationByKey(code) {
                return this.validationErrors ? this.validationErrors[code] || [] : [];
            },
            resetForm() {
                this.form = {
                    id: null,
                    customerNo: '',
                    name: '',
                    customerType: 0,
                    responsible: null
                };
                this.validationErrors = null;
            },
            async getAllUsersByCustomerId() {
                const customerId = this.form.id || 0;

                await get('UserCustomerPermission', `GetAllUsersByCustomerId/${customerId}`)
                    .then((x) => {
                        this.responsibles = x.data;                 
                        this.validationErrors = x.data.errors;
                    })
                    .catch(x => {
                        this.isSubmitting = false;
                        this.validationErrors = x.response.data.errors;
                    });
            }
        }
    };
</script>

<style scoped>
    .form-group {
        margin-bottom: 0.5rem;
    }
</style>
